import { apiPost } from '@/lib/http/client';

/** entity_type_name of a scheduled automation (the only type the Run now button targets). */
export const SCHEDULED_AUTOMATION_ENTITY_TYPE = 'ahoy_scheduled_automation';

export interface RunNowResponse {
  status: 'queued';
  detail: string;
}

/**
 * Queue a scheduled automation to fire off-schedule. The run executes in the
 * background — this resolves as soon as the fire is queued (202), and the
 * outcome lands as an `ahoy_automation_ran` record on the automation's Runs
 * tab. Rejects on non-2xx (404 not-found, 429 rate-limited) so the caller can
 * surface an error toast.
 */
export async function triggerRunNow(
  orgId: number,
  automationEntityId: string
): Promise<RunNowResponse> {
  return apiPost<RunNowResponse>(
    `/api/orgs/${orgId}/automations/${automationEntityId}/run-now/`,
    {}
  );
}
